import { Metamodel } from 'app/model/base/model';
import { SqlCopySource } from './sql.copysource';
import { SqlServerTableDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'SqlServerSource',
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(SqlServerTableDataset)] }
})
export class SqlServerCopySource extends SqlCopySource {
    public constructor() {
        super();
        this.queryTimeout = 120;
    }
}
